import React from 'react';
import Card from './Card.js';
import img1 from '../imgs/img1.png';
import img2 from '../imgs/img2.png';
import img3 from '../imgs/img3.png';
import img4 from '../imgs/img4.png';
import img5 from '../imgs/img5.png';
import img6 from '../imgs/img6.png';

const Cards = () => {
	return (
		<div>
			<Card
				img={img1}
				author_name={'Kevin Kwan'}
				book_name={'Crazy rich asians'}
				filled={3}
				review={252}
				desc={
					'The outrageously funny debut novel about three super-rich, pedigreed Chinese families and the gossip...'
				}
				price={'$12.99'}
				cutPrice={'$24.99'}
			/>
			<Card
				img={img2}
				author_name={'Margaret Atwood'}
				book_name={'The handmaid’s tale'}
				filled={4}
				review={'1.1M'}
				desc={
					"This novel can be interpreted as a double narrative, Offred's tale and the handmaids' tales. The night..."
				}
				price={'$6.99'}
				cutPrice={'$18.99'}
			/>
			<Card
				img={img3}
				author_name={'Aldous Huxley'}
				book_name={'Brave new world'}
				filled={1}
				review={'1.3M'}
				desc={
					'Dystopian novel written in 1931 by English author Aldous Huxley, and published in 1932. Largely set in...'
				}
				price={'$12.43'}
				cutPrice={'$42.50'}
			/>
			<Card
				img={img4}
				author_name={'Tara Westover'}
				book_name={'Educated'}
				filled={5}
				review={364}
				desc={
					'It is a tale of fierce family loyalty and of the grief that comes with severing the closest of ties. With...'
				}
				price={'$12.99'}
				cutPrice={'$34.20'}
			/>
			<Card
				img={img6}
				author_name={'Marianne Fritz'}
				book_name={'The weight of things'}
				filled={3}
				review={353}
				desc={
					'You discover not an eccentric fluke of literary nature but rather a brilliant and masterful satiris...'
				}
				price={'$18.23'}
				cutPrice={'$34.20'}
			/>
			<Card
				img={img5}
				author_name={'Chris Power'}
				book_name={'Mothers stories'}
				filled={2}
				review={454}
				desc={
					'the stories in Mothers lay bare the emotional and psychic damage of life, love, and abandonment...'
				}
				price={'$18.49'}
				cutPrice={'$20.76'}
			/>
		</div>
	);
};

export default Cards;
